import React, { useState } from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';

interface StarRatingProps {
  onRate: (rating: number) => void;
  initialRating?: number;
}

export const StarRating = ({ onRate, initialRating = 0 }: StarRatingProps) => {
  const [rating, setRating] = useState(initialRating);
  const [hover, setHover] = useState(0);

  const handleRate = (value: number) => {
    setRating(value);
    onRate(value);
  };

  return (
    <div className="flex flex-col items-center gap-2">
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <motion.button
            key={star}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="focus:outline-none"
            onMouseEnter={() => setHover(star)}
            onMouseLeave={() => setHover(0)}
            onClick={() => handleRate(star)}
            aria-label={`Rate ${star} stars`}
          >
            <Star
              size={24}
              className={`${
                star <= (hover || rating)
                  ? 'text-yellow-400 fill-yellow-400'
                  : 'text-gray-300'
              } transition-colors duration-200`}
            />
          </motion.button>
        ))}
      </div>
      <p className="text-sm text-gray-400">
        {rating > 0 ? 'Thanks for rating!' : 'Rate this app'}
      </p>
    </div>
  );
};